import { BrowserRouter } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";
import "./assets/fonts/font_face.css";
import './assets/scss_index.scss';
import 'react-quill/dist/quill.snow.css';
import Footer from "./Components/Organisms/footer/Footer";
import TopNavBar from './Components/Organisms/top_nav_bar/TopNavBar';
import AiChatWidget from './Components/Organisms/ai_chat_widget/AiChatWidget';
import AppRouter from './config/app_router/AppRouter';
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import { PublicStore } from './store/PublicStore';
import './App.scss';

function App() {

  const { fetchData } = PublicStore();

  useEffect(() => {
    fetchData();
  }, [])

  useEffect(() => {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) {
      document.querySelectorAll(".reveal-on-scroll").forEach((el) => {
        el.classList.add("is-visible");
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -5% 0px" }
    );

    const observeTargets = () => {
      document.querySelectorAll(".reveal-on-scroll:not(.is-visible)").forEach((el) => {
        observer.observe(el);
      });
    };

    observeTargets();

    const mainRoot = document.querySelector(".Main");
    const mutationObserver = new MutationObserver(() => {
      observeTargets();
    });

    if (mainRoot) {
      mutationObserver.observe(mainRoot, { childList: true, subtree: true });
    }

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, []);


  return (
    <div className="App">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <BrowserRouter>
        <TopNavBar />
        <div className='Main' id="main-content" tabIndex={-1}>
          <AppRouter />
        </div>
        <Footer />
        <AiChatWidget />
        <ToastContainer
          position="top-right"
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
